export function checkboxSquarePartiallyChecked() {
  return (
    <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Right Icon">
        <path
          id="Vector"
          d="M15.8333 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5ZM13.3333 10.8333H6.66667C6.20833 10.8333 5.83333 10.4583 5.83333 10C5.83333 9.54167 6.20833 9.16667 6.66667 9.16667H13.3333C13.7917 9.16667 14.1667 9.54167 14.1667 10C14.1667 10.4583 13.7917 10.8333 13.3333 10.8333Z"
          fill="#838C89"
          fillOpacity="0.7"
        />
      </g>
    </svg>
  );
}
